<template>
	<div :id="id" class="position-relative filter-container">
		<v-date-picker
				v-if="typeFilter === 'date'"
				class="picker-table"
				width="300"
				color="green"
				:disabled="isDisabled"
				v-model="dates"
				@input="onChange"
				range
		></v-date-picker>
		<v-text-field
				v-else-if="typeFilter === 'note'"
				v-model="note"
				@input="onFilterNote"
				:label="'Enter ' + labelFilter"
				class="mx-4 search-table"
		></v-text-field>
		<div
				v-else-if="typeFilter === 'number'"
				class="numberWR"
		>
			<type-number
					:condition="conditionRefresh"
					:filterName="modelFilter"
					@updateNumber="onChangeNumber"
			></type-number>
		</div>
		<v-autocomplete
				v-else
				class="green-icon"
				v-model="select"
				:items="getNumberToString"
				:label="'Select ' + labelFilter"
				item-text="value"
				item-value="id"
				color="green"
				:attach="'#'+id"
				:menu-props="{contentClass: 'filter-dd', maxWidth: 300, minWidth: 300, nudgeWidth: 300}"
				@change="changeFilter($event)"
				multiple
				clearable
				small-chips
				deletable-chips
				chips
		></v-autocomplete>

	</div>
</template>
<script>
import { mapActions } from "vuex";
import TypeNumber from "@/shared/table/filter-table/TypeNumber/TypeNumber";
import debounce from "lodash.debounce";
import getDefaultDate from "@/helper/getDefaultDate";

export default {
	components: {
		TypeNumber
	},
	props: {
		isDisabled: Boolean,
		dataFilter: {
			type: Array,
			default: () => []
		},
		modelFilter: {
			type: String,
			default: ''
		},
		filterUpdate: {
			type: Boolean
		},
		labelFilter: {
			type: String
		},
		typeFilter: {
			type: String,
			default: 'list'
		},
		uniqId: Object,
		refreshDate: String
	},
	watch: {
		uniqId(val, oldVal) {
			const model = this.typeFilter;
			const { id, key } = val;
			const { id: oldId } = oldVal;
			if (id !== oldId && this.modelFilter === key) {
				this.select = this.items.map(item => item.id);
				this.$emit("change-sort", { key: this.modelFilter, value: this.select, model });
			}
		},
		filterUpdate(val) {
			if (val) {
				this.conditionRefresh = val;
				this.select = [];
				this.note = '';
				this.$emit('create-refresh', this.modelFilter);
			}
		},
		refreshDate(val, oldVal) {
			if (val !== oldVal) {
				if (this.modelFilter === 'filter_status_serves') {
					this.select = [ 1 ];
				} else {
					this.select = [];
				}

				this.dates = new Date().toISOString().substr(0, 10);
				this.conditionRefresh = val;
				this.note = '';
			}
		}
	},
	computed: {
		getNumberToString() {
			return this.items.map(item => ({ id: item.id, value: item.value + '' }));
		},
		items() {
			return this.dataFilter.filter((value) => value != null && value);
		},
		id() {
			return "dd" + Math.round((Math.random() * (1000 - 20)) + 10);
		},
		update() {
			return this.filterUpdate;
		},
	},
	data() {
		return {
			note: '',
			conditionRefresh: null,
			select: [],
			dates: [ getDefaultDate() ]
		};
	},
	methods: {
		...mapActions([ 'safetyCalendar' ]),
		onChangeNumber(values) {
			const model = this.typeFilter;
			const key = this.modelFilter;
			const value = { type: values.type, value: values.value };

			this.$emit("change-sort", { key, value, model });
		},
		changeFilter(value) {
			const model = this.typeFilter;
			const key = this.modelFilter;

			this.$emit("change-sort", { key, value, model });
		},
		onChange() {
			const model = this.typeFilter;
			const key = this.modelFilter;
			const [ from, to = from ] = this.dates;
			const value = { from, to };
			this.$emit("change-sort", { key, value, model });
		},
		onFilterNote: debounce(function() {
			const model = this.typeFilter;
			const key = this.modelFilter;
			const value = this.note.toLowerCase();

			this.$emit("change-sort", { key, value, model });
		}, 300)
	},
	mounted() {
		this.$emit('filter-created', this.modelFilter);
		if (this.modelFilter === 'filter_status_serves') this.select = [ 1 ];
	},
};
</script>
<style lang="scss" scoped>
.filter-container {
	.numberWR {
		padding-top: 15px;
	}
}
</style>
<style lang="scss">
@import './filter-table.component';
</style>
